<template>
    <div class="article-week">
        <loading-block v-if="topArticlesLoading" />
        <div v-else>
            <div v-if="topArticles.length > 0">
<!--                <div class="head-article" v-for="item in topArticles.slice(0,1)" v-bind:key="item._id">-->
<!--                    <img alt="" :src="!isEmpty(item.file) ? item.file[0].fullpath : '/assets/images/icons/image.png'">-->
<!--                    <div class="head-article-date">{{ moment(item.date) }}</div>-->
<!--                    <a :href="item.url" title="" target="_blank">-->
<!--                        <h3 class="head-article-title">{{ item.title }}</h3>-->
<!--                    </a>-->
<!--                    <p class="head-article-desc">{{ item.description }}</p>-->
<!--                    <div class="head-article-author">-->
<!--                        <div class="head-article-author-name">-->
<!--                            {{ item.author.name }}-->
<!--                        </div>-->
<!--                        <div class="article-views">-->
<!--                            <i class="icon icon-eye"></i> {{ nFormatter(item.view_count, 0) }}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <small-card
                    v-for="item in topArticles"
                   
                    :key="item.id"
                    :id="item.id"
                    :image="!isEmpty(item.cover) ? item.cover : '/assets/images/icons/image.png'"
                    :title="item.title"
                    :date="item.date"
                    :author="item.username"
                    
                    :url="item.url"
                />
            </div>
            <div v-else class="text-center">
                <p>Tidak ada top artikel</p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.article-week {
    /*padding: 0 5%;*/
}
.head-article {
    width: 100%;
    margin-bottom: 20px;
}
.head-article a {
    color: #333333;
}
.head-article a:hover {
    text-decoration: none;
}
.head-article img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
}
.head-article-date {
    color: #828282;
    font-size: 12px;
    margin-bottom: 10px;
}
.head-article .head-article-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
}
.head-article .head-article-desc {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #828282;
    margin-bottom: 5px;
}
.head-article-author {
    display: flex;
    align-items: center;
    flex-direction: row;
}
.article-views {
    display: flex;
    align-items: center;
    margin-left: 15px;
}
.article-views i {
    margin-right: 5px;
}
.article-views {
    margin-right: 5px;
    color: #BDBDBD;
}
.head-article-author .head-article-author-name {
    font-style: italic;
    color: #4F4F4F;
}
</style>
<script>
import axios from "axios";
import moment from "moment";
import _ from 'lodash';
import {nFormatter} from '../NumberFormatter.js'
import SmallCard from "./Card/SmallCard";

export default {
    components: {
        SmallCard
    },
    data() {
        return {
            loading: true,
            topArticles: [],
            topArticlesLoading: true
        }
    },
    mounted() {
        this.getTopArticle()
    },
    methods: {
        getTopArticle() {
            const token = this.$cookies.get('token');
            axios.get(`/api/widget/top/article`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.topArticles = response.data
                   
                    this.topArticlesLoading = false
                })
                .catch((error) => {

                });
        },
        moment (date) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        },
        isEmpty (value) {
            return _.isEmpty(value)
        },
        nFormatter(num, digits) {
            return nFormatter(num, digits)
        }
    }
}
</script>
